import { render, staticRenderFns } from "./ControleAjusteParcial.vue?vue&type=template&id=0a0d1d30&"
import script from "./ControleAjusteParcial.vue?vue&type=script&lang=js&"
export * from "./ControleAjusteParcial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports